import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { GroupStorage } from "../../models";
import { GroupStorageGuard } from "../guards/group-storage.guard";
import { HostGuard } from "../guards/host.guard";
import { ActiveDirectoryComponent } from "./active-directory/active-directory.component";
import { ConnectionsComponent } from "./connections.component";
import { Dynamics365Component } from "./dynamics365/dynamics365.component";
import { SharePointModule } from "./sharepoint/sharepoint.module";
import { EntraIdComponent } from "./entra-id/entra-id.component";

const routes: Routes = [
  {
    path: "",
    component: ConnectionsComponent
  },
  {
    path: "active-directory",
    component: ActiveDirectoryComponent,
    canActivate: [HostGuard, GroupStorageGuard],
    data: { groupStorage: GroupStorage.ActiveDirectory }
  },
  {
    path: "entra-id",
    component: EntraIdComponent,
    canActivate: [GroupStorageGuard],
    data: { groupStorage: GroupStorage.AzureActiveDirectory }
  },
  {
    path: "dynamics-365",
    component: Dynamics365Component
  },
  {
    path: "sharepoint",
    loadChildren: () => SharePointModule
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConnectionsRoutingModule {}
